import { Link } from 'react-router-dom';

const PolitiqueConfidentialite = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm border p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de confidentialité</h1>
        
        <div className="space-y-8">
          {/* Introduction */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Introduction</h2>
            <div className="space-y-2 text-gray-700">
              <p>La présente politique de confidentialité décrit comment EasyRDV collecte, utilise et protège vos informations personnelles lorsque vous utilisez notre plateforme de prise de rendez-vous.</p>
              <p>Nous nous engageons à protéger votre vie privée et à traiter vos données personnelles de manière transparente et sécurisée, conformément au Règlement Général sur la Protection des Données (RGPD).</p>
            </div>
          </section>

          {/* Responsable du traitement */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Responsable du traitement</h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>Nom :</strong> EasyRDV</p>
              <p><strong>Développeur :</strong> Yassine Hamdoune</p>
              <p><strong>Email :</strong> hamdouneyassine.03@gmail.com</p>
              <p><strong>Adresse :</strong> France</p>
            </div>
          </section>

          {/* Données collectées */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Données personnelles collectées</h2>
            <div className="space-y-4 text-gray-700">
              <div>
                <h3 className="text-lg font-medium text-gray-800 mb-2">Données d'identification</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Nom et prénom</li>
                  <li>Adresse email</li>
                  <li>Numéro de téléphone (optionnel)</li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-800 mb-2">Données de connexion</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Adresse IP</li>
                  <li>Données de navigation</li>
                  <li>Cookies de session</li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-800 mb-2">Données de rendez-vous</h3>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Date et heure des rendez-vous</li>
                  <li>Motif du rendez-vous</li>
                  <li>Notes et commentaires</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Finalités du traitement */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Finalités du traitement</h2>
            <div className="space-y-2 text-gray-700">
              <p>Vos données personnelles sont collectées et traitées pour les finalités suivantes :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Gestion de votre compte utilisateur</li>
                <li>Organisation et suivi de vos rendez-vous</li>
                <li>Communication relative à vos rendez-vous</li>
                <li>Amélioration de nos services</li>
                <li>Assistance technique et support client</li>
                <li>Respect de nos obligations légales</li>
              </ul>
            </div>
          </section>

          {/* Base légale */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Base légale du traitement</h2>
            <div className="space-y-2 text-gray-700">
              <p>Le traitement de vos données personnelles est fondé sur :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>L'exécution du contrat :</strong> Pour la fourniture de nos services de prise de rendez-vous</li>
                <li><strong>L'intérêt légitime :</strong> Pour l'amélioration de nos services et la sécurité</li>
                <li><strong>Le consentement :</strong> Pour les communications marketing (si applicable)</li>
                <li><strong>L'obligation légale :</strong> Pour respecter nos obligations réglementaires</li>
              </ul>
            </div>
          </section>

          {/* Destinataires */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Destinataires des données</h2>
            <div className="space-y-2 text-gray-700">
              <p>Vos données personnelles peuvent être partagées avec :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Notre équipe technique pour la maintenance et le support</li>
                <li>Nos prestataires de services (hébergement, sécurité)</li>
                <li>Les autorités compétentes si requis par la loi</li>
              </ul>
              <p className="mt-4">Nous ne vendons, ne louons ni ne partageons vos données personnelles avec des tiers à des fins commerciales.</p>
            </div>
          </section>

          {/* Durée de conservation */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Durée de conservation</h2>
            <div className="space-y-2 text-gray-700">
              <p>Vos données personnelles sont conservées :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Données de compte :</strong> Pendant la durée de votre inscription + 3 ans</li>
                <li><strong>Données de rendez-vous :</strong> 5 ans à compter de la date du rendez-vous</li>
                <li><strong>Données de connexion :</strong> 12 mois</li>
                <li><strong>Cookies :</strong> Selon la durée définie dans notre politique cookies</li>
              </ul>
            </div>
          </section>

          {/* Vos droits */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Vos droits</h2>
            <div className="space-y-2 text-gray-700">
              <p>Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li><strong>Droit d'accès :</strong> Connaître les données vous concernant</li>
                <li><strong>Droit de rectification :</strong> Corriger des données inexactes</li>
                <li><strong>Droit à l'effacement :</strong> Supprimer vos données</li>
                <li><strong>Droit à la limitation :</strong> Limiter le traitement</li>
                <li><strong>Droit à la portabilité :</strong> Récupérer vos données</li>
                <li><strong>Droit d'opposition :</strong> Vous opposer au traitement</li>
                <li><strong>Droit de retrait du consentement :</strong> Retirer votre consentement</li>
              </ul>
              <p className="mt-4">Pour exercer ces droits, contactez-nous à : hamdouneyassine.03@gmail.com</p>
            </div>
          </section>

          {/* Sécurité */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Sécurité des données</h2>
            <div className="space-y-2 text-gray-700">
              <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>L'accès non autorisé</li>
                <li>La divulgation accidentelle</li>
                <li>La perte ou destruction</li>
                <li>L'altération</li>
              </ul>
              <p className="mt-4">Nos mesures de sécurité incluent le chiffrement des données, l'authentification sécurisée et des sauvegardes régulières.</p>
            </div>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Cookies</h2>
            <div className="space-y-2 text-gray-700">
              <p>Notre site utilise des cookies pour améliorer votre expérience utilisateur. Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter le fonctionnement de certaines fonctionnalités.</p>
              <p>Pour plus d'informations sur notre utilisation des cookies, consultez notre politique cookies.</p>
            </div>
          </section>

          {/* Modifications */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Modifications de cette politique</h2>
            <div className="space-y-2 text-gray-700">
              <p>Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur cette page avec une date de mise à jour.</p>
              <p>Nous vous encourageons à consulter régulièrement cette politique pour rester informé de nos pratiques.</p>
            </div>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact</h2>
            <div className="space-y-2 text-gray-700">
              <p>Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, contactez-nous :</p>
              <p><strong>Email :</strong> hamdouneyassine.03@gmail.com</p>
              <p><strong>Développeur :</strong> Yassine Hamdoune</p>
            </div>
          </section>

          {/* Dernière mise à jour */}
          <section className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600">
              <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}
            </p>
          </section>
        </div>

        {/* Back to home */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium"
          >
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite; 